module.exports = __webpack_public_path__ + "static/media/LokiFrame89.84c1e306.png";